export const schema = {
  models: {
    FlowV1: {
      id: Number,
      owner: String,
      type: String,
      dataType: String,
      lastExecution: String,
      lastExecutionStatus: Boolean,
      users: Array,
      name: String,
      tasks: Object,
      settings: {
        domains: Object,
        reference: {
          storageOption: String,
          label: String,
          type: String,
          value: String,
        },
        authentication: {
          authUrl: String,
          location: String,
          storageOption: String,
          label: String,
          redirectUrl: String,
        },
      },
    },
    FlowV2: {
      id: Number,
      owner: String,
      tableID: String,
      type: String,
      dataType: String,
      lastExecution: String,
      lastExecutionStatus: Boolean,
      users: Array,
      name: String,
      tasks: Object,
      settings: {
        domains: Object,
        reference: {
          storageOption: String,
          label: String,
          type: String,
          value: String,
        },
        authentication: {
          authUrl: String,
          location: String,
          storageOption: String,
          label: String,
          redirectUrl: String,
        },
      },
    },
    FlowV3: {
      id: Number,
      owner: String,
      tableID: String,
      type: String,
      dataType: String,
      lastExecution: String,
      lastExecutionStatus: Boolean,
      name: String,
      tasks: Object,
      settings: {
        fullWith: Boolean,
        btnCaption: String,
        loadingCaption: String,
        brandingColor: String,
        domains: Object,
        reference: {
          storageOption: String,
          label: String,
          type: String,
          value: String,
        },
        authentication: {
          authUrl: String,
          location: String,
          storageOption: String,
          label: String,
          redirectUrl: String,
        },
      },
    },
    FlowV4: {
      id: Number,
      owner: String,
      tableID: String,
      type: String,
      dataType: String,
      lastExecution: String,
      lastExecutionStatus: Boolean,
      name: String,
      tasks: Object,
      settings: {
        fullWith: Boolean,
        btnCaption: String,
        loadingCaption: String,
        brandingColor: String,
        domains: Object,
        reference: {
          storageOption: String,
          label: String,
          type: String,
          value: String,
        },
        authentication: {
          authUrl: String,
          location: String,
          storageOption: String,
          label: String,
          redirectUrl: String,
        },
      },
      tags: Array,
    },
  },
};
